<template>
  <div>
    <el-card
      class="card-container"
      shadow="never"
    >
      <CardHeader
        slot="header"
        title="Tài khoản"
        :total="total"
        :size="'small'"
        :disabled="loading"
        :permission="createPermission"
        :role-permission="rolePermission"
        @create="handleCreate"
        @refresh="handleRefresh"
      />
      <div>
        <CardFilter />
        <CardList
          :data="data"
          :loading="loading"
          :permission="permission"
          :account-permission="accountPermission"
          @update="handleUpdate"
          @delete="handleDelete"
        />
        <el-row
          type="flex"
          align="middle"
          justify="end"
          class="mt-l"
        >
          <el-pagination
            background
            :current-page="page"
            :page-sizes="[10, 20, 50, 100, 500, 1000]"
            :page-size="pageSize"
            :total="total"
            layout="total, sizes, prev, pager, next, jumper"
            @size-change="handleChangePageSize"
            @current-change="handleChangePage"
          />
        </el-row>
      </div>
      <DataFormPopup
        v-if="formVisible"
        :item="selectedItem"
        :visible="formVisible"
        :organization-id="organizationId"
        :permission="permission"
        :account-permission="accountPermission"
        :role-permission="rolePermission"
        @close="formVisible = false"
        @reload="listData"
      />
    </el-card>
  </div>
</template>

<script>
import CardFilter from "./components/CardFilter.vue";
import CardHeader from "./components/CardHeader.vue";
import CardList from "./components/CardList.vue";
import DataFormPopup from "./popups/DataForm.vue";

import { notification } from "@/utils/common";
import roleUserServices from "@/services/role-user";
import organizationServices from "@/services/organization";
import iamResourceServices from "@/services/iam-resource";
import constants from "@/config/constants";
import { roleUserPer, createAccountPer, accountPer, rolePer } from "@/utils/permission";

export default {
  name: "UserRoles",
  components: {
    CardHeader,
    CardFilter,
    CardList,
    DataFormPopup,
  },
  data() {
    return {
      loading: false,
      searchText: "",
      page: 1,
      pageSize: constants.PAGE_SIZE,
      total: 0,
      data: [],
      selectedItem: null,
      formVisible: false,
      organizationId: organizationServices.getCurrentOrg()?.id,
      permission: roleUserPer(),
      accountPermission: accountPer(),
      createPermission: createAccountPer(),
      rolePermission: rolePer()
    };
  },
  computed: {
    params() {
      const _params = {
        offset: (this.page - 1) * this.pageSize,
        limit: this.page * this.pageSize,
        locale: "en",
        filters: {
          organization_id: this.organizationId,
        }
      };
      if (this.searchText) {
        _params.filters[`name`] = { $regex: this.searchText }
      }
      return _params;
    },
  },
  beforeMount() {
    iamResourceServices.list();
    this.listData();
  },
  methods: {
    listData() {
      this.loading = true;
      roleUserServices
        .list(this.params)
        .then((response) => {
          this.data = response.items.map((item, index) => ({
            ...item,
            stt: index + 1 + this.pageSize * (this.page - 1),
          }));
          this.total = response.meta.total;
          this.loading = false;
        })
        .catch(() => {
          this.data = [];
          this.loading = false;
        });
    },
    handleCreate() {
      this.selectedItem = null;
      this.formVisible = true;
    },
    handleUpdate(item) {
      this.selectedItem = item;
      this.formVisible = true;
    },
    handleDelete(item) {
      this.$confirm(`Bạn có chắc chắn muốn xoá không?`, "Xác nhận", {
        confirmButtonText: "Xoá",
        cancelButtonText: "Huỷ",
        type: "warning",
      }).then(() => {
        roleUserServices
          .remove(item)
          .then(() => {
            if (this.data.length === 1 && this.page > 1) {
              this.page = this.page - 1;
            }
            this.listData();
            notification(this, "success", "delete", "tài khoản");
          })
          .catch(() => {
            notification(this, "error", "delete", "tài khoản");
          });
      });
    },
    handleSearch() {
      this.page = 1;
      this.listData();
    },
    handleRefresh() {
      this.selectedItem = null;
      this.page = 1;
      this.searchText = "";
      this.listData();
    },
    handleChangePage(page) {
      this.page = page;
      this.listData();
    },
    handleChangePageSize(size) {
      this.page = 1;
      this.pageSize = size;
      this.listData();
    },
  },
};
</script>

<style lang="scss"></style>
